import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';

interface QuizResultScreenProps {
  onBack: () => void;
  message?: string;
  highlighted?: boolean;
}

export const QuizResultScreen: React.FC<QuizResultScreenProps> = ({
  onBack,
  message = 'You have mastered all 20 words in this set!',
  highlighted = false,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6, textAlign: 'center' }}>
      <Typography variant="h4" sx={{ fontWeight: 'black', mb: 2 }}>
        🥳 Set Complete! 🎉
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: highlighted ? theme.palette.common.white : 'text.secondary' }}>
        {message}
      </Typography>
      <Button variant="contained" color="primary" onClick={onBack}>
        Choose Another Set
      </Button>
    </Box>
  );
};
